var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[(_vm.src)?_c('iframe',{ref:"myIFrame",staticStyle:{"position":"absolute","width":"100%","height":"100%","border":"0px"},attrs:{"src":_vm.src}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }